import * as React from 'react';
import { useState } from 'react';
import { Field as FinalField } from 'react-final-form';

import { Input } from '@lendi-ui/text-input';
import { HiddenLUIField, HiddenLUIInputDiv } from './index.style';

export interface HiddenFieldProps {
  disableFailMessage?: boolean;
  name: string;
  isOptional?: boolean;
  validate: (value: any) => any;
  onTouched?: (touched: boolean | undefined) => any;
  onValidate?: (error: any | undefined) => any;
}

const HiddenField = (props: HiddenFieldProps) => {
  const { name, isOptional, onTouched, onValidate, validate, disableFailMessage = false } = props;
  const [error, setError] = useState(undefined);
  const [touched, setTouched] = useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    if (onValidate) onValidate(error);
  }, [error]);

  React.useEffect(() => {
    if (onTouched) onTouched(touched);
  }, [touched]);

  const fieldProps = {
    name,
    key: isOptional ? 'optional' : 'required',
    validate,
  };

  return (
    <FinalField {...fieldProps}>
      {({ input, meta }) => {
        setError(disableFailMessage ? undefined : meta.error);
        setTouched(meta.touched);
        return (
          <HiddenLUIField {...meta} error={disableFailMessage ? undefined : meta.error}>
            <HiddenLUIInputDiv>
              <Input {...input} />
            </HiddenLUIInputDiv>
          </HiddenLUIField>
        );
      }}
    </FinalField>
  );
};

export default HiddenField;
